import type { RouteRecordRaw } from 'vue-router'

export const inventoryRoutes: RouteRecordRaw[] = [
  {
    path: '/objects/:type/:object_id/:tab(inventory)',
    component: () => import('@/pages/inventory/Index'),
    name: 'object.inventory',
    meta: {
      layout: 'dash',
      protected: true,
    },
    children: [
      {
        path: ':tab_inventory(map)',
        redirect: (to) => ({
          path: `/objects/${to.params.type}/${to.params.object_id}/map`,
          query: to.query,
        }),
      },
      {
        path: ':tab_inventory(reports)',
        component: () => import('@/pages/inventory/Reports'),
        name: 'object.inventory.map',
      },
      {
        path: ':tab_inventory(list)',
        component: () => import('@/pages/inventory/List'),
        name: 'object.inventory.list',
      },
      {
        path: ':tab_inventory(list)/:invent_object_id',
        component: () => import('@/pages/inventory/ListItem'),
      },
      {
        path: ':tab_inventory(history)/',
        component: () => import('@/pages/inventory/History'),
        name: 'object.inventory.history',
      },
      {
        path: ':tab_inventory(list)/master',
        component: () => import('@/pages/inventory/ObjectCreateMaster'),
        name: 'object.inventory.master',
      },
      {
        path: ':tab_inventory(elements)',
        component: () => import('@/pages/inventory/Elements'),
        name: 'object.inventory.elements',
      },
      {
        path: ':tab_inventory(elements)/:invent_object_id',
        component: () => import('@/pages/inventory/ElementsItem'),
        name: 'object.inventory.elements.edit',
      },
      {
        path: ':tab_inventory(elements)/:invent_object_id/passport-v2',
        component: () => import('@/pages/inventory/ElementsPassportV2'),
        name: 'object.inventory.elements.passport-v2',
      },
      {
        path: ':invent_type_id(\\d+)/:tab_inventory(elements)/create-v2',
        component: () =>
          import('@/pages/inventory/CreatePassportV2Batch/ui/CreatePassportV2BatchPage.vue'),
        name: 'object.inventory.type.elements.create-v2',
        meta: {
          layout: 'dash',
          protected: true,
        },
      },
      {
        path: ':invent_type_id(\\d+)/:tab_inventory(elements)',
        component: () => import('@/pages/inventory/ElementsByType'),
        name: 'object.inventory.type.elements',
      },
    ],
  },
  {
    path: '/objects/:type/:object_id/:tab(import)',
    component: () => import('@/pages/inventory/Import'),
    name: 'object.inventory.import',
    meta: {
      layout: 'dash',
      protected: true,
    },
  },
]
